import type { Section } from '@viome/viome-base/src/api/Strapi/StrapiTypes';

type AddonWhatsInsideProps = {
  whatsInside?: Section;
  delivered?: Section;
  className?: string;
};

export const AddonWhatsInside = ({
  whatsInside,
  delivered,
  className,
}: AddonWhatsInsideProps) => {
  return (
    <div className={className}>
      <h2 className="font-sans text-xl font-medium text-[#111] tracking-tight mb-5">
        What&apos;s Inside
      </h2>

      {whatsInside?.items && whatsInside.items.length > 0 && (
        <div className="bg-white rounded-[6px] border border-gray-100 overflow-hidden divide-y divide-gray-100">
          {whatsInside.items.map((item, idx) => (
            <div key={idx} className="px-4 py-4">
              <div className="flex items-center justify-between mb-1.5 gap-2">
                <p className="font-sans text-sm font-medium text-[#111] tracking-tight">
                  {item.title}
                </p>
                {item.badge && (
                  <span className="font-sans font-medium bg-[#F0F8F7] text-[#146464] text-[11px] rounded-full px-2.5 py-0.5 shrink-0">
                    {item.badge}
                  </span>
                )}
              </div>
              <p className="font-sans font-light text-sm leading-[130%] text-tertiary">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      )}

      {delivered && (
        <div className="bg-[#111] rounded-md p-5 mt-8">
          {delivered.title && (
            <p className="font-sans text-[15px] font-medium text-white tracking-tight">
              {delivered.title}
            </p>
          )}
          {delivered.description && (
            <p className="font-sans font-light text-[13px] text-white/60 leading-[1.6] mt-2">
              {delivered.description}
            </p>
          )}
          {delivered.highlights && delivered.highlights.length > 0 && (
            <div className="flex gap-2.5 mt-5">
              {delivered.highlights.map((stat, idx) => (
                <div
                  key={idx}
                  className="flex-1 bg-white/[0.08] rounded p-3"
                >
                  <p className="font-sans text-xl font-medium text-[#009e82] tracking-tight">
                    {stat.value}
                  </p>
                  <p className="font-sans font-light text-[11px] text-white mt-0.5">
                    {stat.description}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
